export default[
    {
        path: '/parametres',
        name: 'parametres',
        component: () => import('@/views/assureur//parametres/Parametres.vue'),
    }
]